/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Twittercard1Inputs */

const ja_metadata_twittercard1 = /** @type {(inputs: Metadata_Twittercard1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`summary_large_image`)
};

const en_metadata_twittercard1 = /** @type {(inputs: Metadata_Twittercard1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`summary_large_image`)
};

/**
* | output |
* | --- |
* | "summary_large_image" |
*
* @param {Metadata_Twittercard1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const metadata_twittercard1 = /** @type {((inputs?: Metadata_Twittercard1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Twittercard1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_twittercard1(inputs)
	return en_metadata_twittercard1(inputs)
});
export { metadata_twittercard1 as "metadata_twitterCard" }